module.exports = __webpack_public_path__ + "img/environment8.db9d7cc5.png";